import React, { useState, useEffect } from "react";
import FirstCardSection from "./First-Card-Section";

import RoomDetailsCard from "./Room-Details-Card";

//imports for user data
import { useSelector, useDispatch } from "react-redux";

//functions for datat fetching
import { getProfile } from "../../../../redux/slices/sliceActions";

const RightSectionPc = () => {
  //before the component mounts
  const [isLoading, setIsLoading] = useState(true);

  //data fetched from the store
  const dispatch = useDispatch();
  const { user,profile } = useSelector((state) => state.landlordslice);
  const token = user?.accessToken;
  const id = user?.user?.user_id;

  const [profileUpdated, setProfileUpdated] = useState(false);
  const [propertyDetails, setPropertyDetails] = useState([]);
  const [landlordDetails, setLandlordDetails] = useState([]);
  const [dataInCards, setDataInCards] = useState({});
  const [paymentProgressInvoices, setPaymentProgressInvoices] = useState([]);
  const [paymentProgressPayments, setPaymentProgressPayments] = useState([]);

  useEffect(() => {
    console.log(user);
    dispatch(getProfile({ id, token, caretaker: true })).then((res) => {
      console.log("profile update", res);
      setProfileUpdated(true);
      setPropertyDetails({
        propertyName: res.payload.property_name || "Not Available",
        propertyLocation: res.payload.property_location || "Not Available",
        waterCharge: res.payload.water_charge || "Not Available",
        totalTenants: res.payload.occupiedHouses || "Not Available",
        totalHouses: res.payload.totalHouses || "Not Available",
        garbageCharge: res.payload.garbage_charges || "Not Available",
      });
      setLandlordDetails({
        name: res.payload.landlord_name || "Not Available",
        phone: res.payload.landlord_phone_number || "Not Available",
        profilePhoto: res.payload.landlord_profile_photo || "Not Available",
      });
      setPaymentProgressInvoices(res.payload.unpaidInvoices);
      setPaymentProgressPayments(res.payload.paidInvoices);
      

      setIsLoading(false);
      // setHouseDetails(res.payload.tenant_details.house_info);
      // setCareTakerDetails(res.payload.tenant_details.caretaker);
      //
      //
    });
  }, [user]);


  useEffect(() => { 
    if (profile?.occupiedHouses) {
      setDataInCards({
        paymentsMade: profile.paidInvoices?.total || 0,
        pendingInvoices: profile.unpaidInvoices?.total || 0,
        numberOfPaymentsMade: profile.totalPaidInvoices || 0,
        numberOfPendingInvoices: profile.totalUnpaidInvoices || 0,
        housesOccupied: profile.occupiedHouses || 0,
        totalHouses: profile.totalHouses || 0,
        arrearsReconciled: profile.totalArrearsPaid || 0,
        totalInvoiceAmount: profile.unpaidInvoices?.amount || 0,
        totalPaymentsAmount: profile.paidInvoices?.amount || 0,
      });
    }
  }, [profile]);

  return (
    <>
      {isLoading ? (
        <div className="loading-container">
          {/* <div className="loader"></div> */}
        </div>
      ) : (
        <div style={{ width: "100%" }}>
          <div className="first-card-section" style={{ width: "100%" }}>
            <FirstCardSection
              paymentProgressInvoices={paymentProgressInvoices}
              paymentProgressPayments={paymentProgressPayments}
                propertyDetails={propertyDetails}
                dataInCards={dataInCards}
            />
            <RoomDetailsCard
              propertyDetails={propertyDetails}
              landlordDetails={landlordDetails}
            />
          </div>
        </div>
      )}
    </>
  );
};

export default RightSectionPc;
